/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Former goog.module ID: Blockly.IRegistrable

/**
 * The interface for a Blockly component that can be registered.
 */
export interface IRegistrable {}
